import { render, staticRenderFns } from "./index.vue?vue&type=template&id=070176bb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=070176bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070176bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070176bb')) {
      api.createRecord('070176bb', component.options)
    } else {
      api.reload('070176bb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=070176bb&scoped=true&", function () {
      api.rerender('070176bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/files-viewer/index.vue"
export default component.exports